import styled from 'styled-components';

export type BackgroundColorType = 'NORMAL' | 'PRIMARY';

function getBackgroundColorByType(color?: BackgroundColorType) {
  const options = {
    NORMAL: 'rgba(0, 0, 0, 0.5)',
    PRIMARY: 'rgba(1, 130, 205, .75)',
  };
  return options[color || 'NORMAL'];
}

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonAlert = styled.button`
  border: none;
  padding: 8px;
  color: ${props => props.theme.color.neutral90};
  background: transparent;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  :last-child {
    color: ${props => props.theme.color.primary};
  }
`;

export const Container = styled.div<{ open?: boolean; backgroundColor?: BackgroundColorType }>`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10000;
  justify-content: center;
  align-items: center;
  background-color: ${p => getBackgroundColorByType(p.backgroundColor)};
  display: ${p => (p.open ? 'flex' : 'none')};
`;

export const Content = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 16px;
  box-sizing: border-box;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  justify-content: center;
  top: -10%;
  z-index: 100;
  align-items: center;
`;

export const Icon = styled.img``;

export const Title = styled.h3`
  padding: 0px 8px;
  font-size: 18px;
  font-weight: 500;
  margin-top: 14px;
  margin-bottom: 14px;
`;

export const Text = styled.a`
  font-size: 18px;
  font-weight: 500;
  margin-top: 14px;
  margin-bottom: 14px;
`;

export const Description = styled.p`
  padding: 0px 8px;
  font-size: 16px;
  line-height: 22px;
  color: ${props => props.theme.color.neutral90};
  margin-bottom: 16px;
`;
